import { IoBook } from 'react-icons/io5';
import './BibleFinisherBadge.css';

const LABEL = 'Finished the whole Bible this season';

const BibleFinisherBadge = () => (
  <span className="bible-finisher-badge" title={LABEL} aria-label={LABEL} role="img">
    <IoBook aria-hidden="true" />
    <span aria-hidden="true">Bible</span>
  </span>
);

export default BibleFinisherBadge;
